import { createSlice } from "@reduxjs/toolkit"

const commonInitialState = {
    notFound: false,
    screenWidth: window.innerWidth,
    donateModal: false,
}

const commonSlice = createSlice({
    name: 'common',
    initialState: commonInitialState,
    reducers: {
        setNotFoundCommon(state, action) {
            state.notFound = action.payload;
        },
        setScreenWidth(state, action) {
            state.screenWidth = action.payload;
        },
        setDonate(state, action) {
            state.donateModal = action.payload
        },
    }
})

export const {
    setNotFoundCommon,
    setScreenWidth,
    setDonate,
} = commonSlice.actions;
export default commonSlice.reducer;